import React from 'react';
import CustomImage from '../custom-image';

const SectionTitle = (props) => {
  const { label, lighttext, boldtext, iconimage, alt, isSectionH1 = true } = props;
  return (
    <div className="section-title-row">
      {iconimage && (
        <div className="title-icon">
          <CustomImage className="custom-icon" imageName={iconimage} alt={alt} maxWidth="90" />
        </div>
      )}
      <div className="section-title">
        {label && <h5 className="small-text">{label}</h5>}
        <h2 className="light-text">{lighttext}</h2>
        {isSectionH1 ? <h1 className="bold-text">{boldtext}</h1> : <h2 className="bold-text">{boldtext}</h2>}
      </div>
    </div>
  );
};

export default SectionTitle;
